export const PASSWORD_FIELD = 'password'
export const PASSWORD_CONFIRM_FIELD = 'confirmPassword'
